import {paramValues,numericRange,selectionLabel} from './early-tomatoes.mjs';
const grammar=`tomat|томаты|томатов
perets|перцы|перца
ogurets|огурцы|огурцов
kapusta|сорта капусты|капусты
kabachok|кабачки|кабачков
zemlyanika-i-klubnika|земляника и клубника|земляники и клубники
tykva|тыквы|тыквы
redis|сорта редиса|редиса
salat|салаты|салата
rozy|розы|роз
baklazhan|баклажаны|баклажанов
luk|сорта лука|лука
liliya|лилии|лилий
arbuz|арбузы|арбузов
gorokh|сорта гороха|гороха
svekla|сорта свёклы|свёклы
bazilik|сорта базилика|базилика
ukrop|сорта укропа|укропа
petuniya|петунии|петунии
dynya|дыни|дыни
morkov|сорта моркови|моркови
viola|виолы|виолы
kukuruza|сорта кукурузы|кукурузы
selderey|сорта сельдерея|сельдерея
fasol|сорта фасоли|фасоли
georgina|георгины|георгин
smorodina|сорта смородины|смородины
podsolnechnik|подсолнечники|подсолнечника
patisson|патиссоны|патиссона
repa|сорта репы|репы
lavanda|сорта лаванды|лаванды
fizalis|сорта физалиса|физалиса
yablonya|яблони|яблони
rukkola-(indau,-dvuryadnik)|сорта рукколы|рукколы
alissum-(lobulyariya)|алиссумы|алиссума
nasturtsiya|настурции|настурции
boby|бобы|бобов
kartofel|сорта картофеля|картофеля
pelargoniya-(geran)|пеларгонии (герани)|пеларгонии (герани)
eustoma-(liziantus)|эустомы|эустомы
myata|сорта мяты|мяты
schavel|сорта щавеля|щавеля
golubika|сорта голубики|голубики
ezhevika|сорта ежевики|ежевики
mayoran|сорта майорана|майорана
barkhatsy-(tagetes)|бархатцы|бархатцев
tsinniya|циннии|циннии
geykhera|гейхеры|гейхеры
tyulpan|тюльпаны|тюльпанов
tuya|туи|туи
begoniya|бегонии|бегонии
dushitsa|сорта душицы|душицы
melissa|сорта мелиссы|мелиссы
petrushka|сорта петрушки|петрушки
shpinat|сорта шпината|шпината
gorchitsa|сорта горчицы|горчицы
koriandr-(kinza)|сорта кориандра (кинзы)|кориандра (кинзы)
gortenziya|гортензии|гортензии
khosta|хосты|хосты
barbaris|барбарисы|барбариса
lileynik|лилейники|лилейника
skabioza|скабиозы|скабиозы
mak|маки|мака
ageratum|агератумы|агератума
ogurechnaya-trava-(borago)|сорта огуречной травы|огуречной травы
tabak|сорта табака|табака
polyn|сорта полыни|полыни
pazhitnik|сорта пажитника|пажитника
khrizantema|хризантемы|хризантемы
chaber|сорта чабера|чабера
estragon-(tarkhun)|сорта эстрагона (тархуна)|эстрагона (тархуна)
issop|сорта иссопа|иссопа
akvilegiya|аквилегии|аквилегии
anemona|анемоны|анемоны
astilba|астильбы|астильбы
vasilek|васильки|василька
kosmeya|космеи|космеи
lyupin|люпины|люпина
malva-(shtok-roza)|мальвы (шток-розы)|мальвы (шток-розы)
monarda|монарды|монарды
pelargoniya|пеларгонии|пеларгонии
salviya-(shalfey)|сальвии (шалфеи)|сальвии (шалфея)
tysyachelistnik|тысячелистники|тысячелистника
floks|флоксы|флокса
kobeya|кобеи|кобеи
nezabudka|незабудки|незабудки
yaskolka|ясколки|ясколки
krokus|крокусы|крокуса
ammi|сорта амми|амми
verbena|вербены|вербены
gazaniya-(gatsaniya)|газании (гацании)|газании (гацании)
fialka|фиалки|фиалки
giatsint|гиацинты|гиацинта
eshsholtsiya|эшшольции|эшшольции
papaver|папаверы|папавера
ochitok|очитки|очитка
osteospermum|остеоспермумы|остеоспермума
makleyya|маклейи|маклейи
geliopsis|гелиопсисы|гелиопсиса
kovyl|сорта ковыля|ковыля
lapchatka|лапчатки|лапчатки
fikus|фикусы|фикуса
valerianella-(valeryannitsa)|сорта валерианеллы|валерианеллы
oves|сорта овса|овса
malina|сорта малины|малины
oblepikha|сорта облепихи|облепихи
aktinidiya|сорта актинидии|актинидии
fistashka|сорта фисташки|фисташки`;
const forms=Object.fromEntries(grammar.split('\n').map(line=>{const [slug,nom,gen]=line.split('|');return [slug,{nom,gen}]}));
export const mixedCulture=c=>['raznye-kustarniki-i-derevya','dekorativnye-raznye','raznoobraznye-komnatnye-rasteniya','raznye-tsvety'].includes(c.slug);
const values=(p,name)=>paramValues(p,name);
const exact=(name,value)=>p=>values(p,name).includes(value);
const strict=(name,allowed)=>p=>{const v=values(p,name);return v.length>0&&v.every(x=>allowed.includes(x))};
const make=(key,label,slug,field,test,adjective='',suffix='')=>({key,label,slug,field,test,adjective,suffix});
const colors=[['red','Красные','krasnye','красные'],['orange','Оранжевые','oranzhevye','оранжевые'],['yellow','Жёлтые','zheltye','жёлтые'],['green','Зелёные','zelenye','зелёные'],['cyan','Голубые','golubye','голубые'],['blue','Синие','sinie','синие'],['black','Чёрные','chernye','чёрные'],['pink','Розовые','rozovye','розовые'],['brown','Коричневые','korichnevye','коричневые'],['crimson','Малиновые','malinovye','малиновые'],['fulvous','Бурые','burye','бурые'],['white','Белые','belye','белые'],['purple','Фиолетовые','fioletovye','фиолетовые'],['bicolor','Двухцветные','dvukhtsvetnye','двухцветные'],['lilac','Сиреневые','sirenevye','сиреневые'],['coral','Коралловые','korallovye','коралловые'],['mixed','Смесь окрасок','smes-okrasok','','со смесью окрасок'],['striped','Полосатые','polosatye','полосатые']];
const monthNames=['январе','феврале','марте','апреле','мае','июне','июле','августе','сентябре','октябре','ноябре','декабре'];
const monthSlugs=['yanvare','fevrale','marte','aprele','mae','iyune','iyule','avguste','sentyabre','oktyabre','noyabre','dekabre'];
export function cultureFacets(c){
 const ornamental=c.parent?.slug==='tsvety-i-komnatnye-rasteniya';
 let f=[make('sort','Сорта','sorta','selection',p=>selectionLabel(p)==='Сорт'),make('hybrid','Гибриды','gibridy','selection',p=>selectionLabel(p)==='Гибрид')];
 if(!ornamental)f.push(make('early','Ранние','rannie','ripening_time',strict('ripening_time',['early','very-early']),'ранние'),make('very-early','Очень ранние','ochen-rannie','ripening_time',strict('ripening_time',['very-early']),'очень ранние'),make('mid-early','Среднеранние','srednerannie','ripening_time',strict('ripening_time',['mid-early']),'среднеранние'),make('mid','Среднего срока','srednego-sroka','ripening_time',strict('ripening_time',['mid']),'','среднего срока созревания'),make('late','Поздние','pozdnie','ripening_time',strict('ripening_time',['late','very-late']),'поздние'),make('remontant','Ремонтантные','remontantnye','ripening_time',exact('ripening_time','remontant'),'ремонтантные'));
 if(!ornamental)f.push(make('det','Детерминантные','determinantnye','growth_type',strict('growth_type',['det','super-det']),'детерминантные'),make('indet','Индетерминантные','indeterminantnye','growth_type',strict('growth_type',['indet']),'индетерминантные'),make('semi-det','Полудетерминантные','poludeterminantnye','growth_type',strict('growth_type',['semi-det']),'полудетерминантные'));
 f.push(...colors.map(([key,label,slug,adj,suffix])=>make(key,label,slug,'color',exact('color',key),adj,suffix)));
 f.push(make('greenhouse','Для теплицы','dlya-teplitsy','environment',exact('environment','greenhouse'),'','для теплицы'),make('outdoor','Для открытого грунта','dlya-otkrytogo-grunta','environment',exact('environment','outdoor'),'','для открытого грунта'),make('house','Для дома','dlya-doma','environment',exact('environment','house'),'','для дома'));
 f.push(make('self','Самоопыляемые','samoopylyaemye','pollination_type',strict('pollination_type',['self']),'самоопыляемые'),make('bee','Пчелоопыляемые','pcheloopylyaemye','pollination_type',strict('pollination_type',['bee']),'пчелоопыляемые'));
 for(const [key,label,slug,adj]of [['shtamb','Штамбовые','shtambovye','штамбовые'],['ampelous','Ампельные','ampelnye','ампельные']])f.push(make(key,label,slug,'stem_type',exact('stem_type',key),adj));
 for(const [key,label,slug,adj]of [['annual','Однолетние','odnoletnie','однолетние'],['biennial','Двулетние','dvuletnie','двулетние'],['perennial','Многолетние','mnogoletnie','многолетние']])f.push(make(key,label,slug,'growth_time',exact('growth_time',key),adj));
 for(const [name,prefix,noun]of [['blooming_time','tsvetenie','цветением'],['fruiting_time','plodonoshenie','плодоношением']])for(let i=0;i<12;i++)f.push(make(prefix+'-'+i,(prefix==='tsvetenie'?'Цветение':'Плодоношение')+': в '+monthNames[i],prefix+'-v-'+monthSlugs[i],name,exact(name,String(i)),'','с '+noun+' в '+monthNames[i]));
 for(const ceiling of [30,60,100])f.push(make('height-'+ceiling,'Высота до '+ceiling+' см','vysota-do-'+ceiling+'-sm','height',p=>{const range=numericRange(p,'height');return range&&Math.max(...range)<=ceiling},'','высотой до '+ceiling+' см'));
 for(const floor of [5,10,15])f.push(make('flower-'+floor,'Цветки от '+floor+' см','tsvetki-ot-'+floor+'-sm','flower_diameter',p=>{const range=numericRange(p,'flower_diameter');return range&&Math.min(...range)>=floor},'','с цветками от '+floor+' см'));
 return f.filter(f=>c.plants.some(f.test));
}
export function normalizeFacets(facets,keys){const unique=[...new Set(keys)];if(unique.some(k=>!facets.some(f=>f.key===k)))return null;const chosen=facets.filter(f=>unique.includes(f.key));return new Set(chosen.map(f=>f.field)).size===chosen.length?chosen:null;}
export const filtered=(c,facets,keys)=>{const fs=normalizeFacets(facets,keys);return fs?c.plants.filter(p=>fs.every(f=>f.test(p))):[]};
export const toggle=(facets,keys,key)=>keys.includes(key)?keys.filter(k=>k!==key):keys.filter(k=>facets.find(f=>f.key===k)?.field!==facets.find(f=>f.key===key)?.field).concat(key);
export const culturePath=(c,fs)=>'/tops/'+c.slug+fs.map(f=>'/'+f.slug).join('');
export function seoCultureHeading(c,fs){
 if(mixedCulture(c))return 'Отзывы о растениях: '+c.title.toLocaleLowerCase('ru')+(fs.length?' — '+fs.map(f=>f.label.toLocaleLowerCase('ru')).join(', '):'');
 const form=forms[c.slug]||{nom:'растения культуры «'+c.title+'»',gen:'культуры «'+c.title+'»'};
 const type=fs.find(f=>f.field==='selection'),adjectives=[...fs].sort((a,b)=>({growth_time:0,stem_type:1,ripening_time:2,growth_type:3,pollination_type:4,color:5}[a.field]??99)-({growth_time:0,stem_type:1,ripening_time:2,growth_type:3,pollination_type:4,color:5}[b.field]??99)).map(f=>f.adjective).filter(Boolean).join(' '),suffixes=fs.map(f=>f.suffix).filter(Boolean).join(' ');
 // Collective crop names use a variety phrase so plural attributes remain grammatical.
 const noun=type?(type.key==='hybrid'?'гибриды ':'сорта ')+form.gen:c.slug==='zemlyanika-i-klubnika'||form.nom.startsWith('сорта ')?'сорта и гибриды '+form.gen:form.nom;
 return 'Лучшие '+(adjectives?adjectives+' ':'')+noun+(suffixes?' '+suffixes:'');
}
export function cultureMeta(c,fs,plants){const h1=seoCultureHeading(c,fs),subject=h1[0].toLocaleUpperCase('ru')+h1.slice(1),canonical='https://uogorod.ru'+culturePath(c,fs);return {h1,title:subject+' — рейтинг и отзывы | Умный огород',description:subject+'. Растений с оценками: '+plants.length+'. Сравните отзывы и '+(fs.length?'признаки: '+fs.map(f=>f.label.toLocaleLowerCase('ru')).join(', '):'характеристики сортов и гибридов')+'.',canonical};}
export const quality=(c,plants,duplicate)=>mixedCulture(c)?'Сборный раздел: сначала уточнить культуру, без общих победителей разных видов':plants.length<5?'Накопление данных: меньше пяти оценённых растений':duplicate?'Проверить самостоятельную пользу: совпадающая выборка':'Кандидат после проверки спроса, содержания и данных';
export const dataGaps=[['Вкус, сладость, аромат','Общая оценка не является отдельной оценкой вкуса. Нужны отдельные публичные оценки по этим качествам.'],['Урожайность по опыту садоводов','В каталоге есть заявленные числа, но сопоставимых публичных результатов выращивания с условиями пока нет.'],['Морозостойкость и устойчивость к болезням','Для этих качеств нет отдельных структурированных признаков в полученном справочнике.'],['Регион: Сибирь, Урал, Подмосковье','Нужны проверенные региональные данные; условия не выводятся из имени сорта или адреса автора.'],['Партенокарпические огурцы','Значение «Самоопыляемый» нельзя автоматически подменять партенокарпией. Нужен отдельный подтверждённый признак.'],['Сладкие/острые перцы, группы роз, кустовые/плетистые формы','Необходима проверенная структурированная классификация этих подгрупп.'],['Годовые победители','Нужна публичная привязка оценок и результатов к конкретному сезону. Личные итоги журнала автоматически не используются.']];
